import React from 'react';
import { IconButtonProps, IconButton } from 'pounceV2';
import LinkButtonWrapperV3, { LinkButtonWrapperPropsV3 } from '../utils/LinkButtonWrapperV3';

type LinkIconButtonProps = LinkButtonWrapperPropsV3 & Omit<IconButtonProps, 'as'>;

const LinkIconButtonV3: React.FC<LinkIconButtonProps> = ({ disabled, external, to, ...rest }) => {
  return (
    <LinkButtonWrapperV3 disabled={disabled} external={external} to={to}>
      <IconButton aria-disabled={disabled} {...rest} />
    </LinkButtonWrapperV3>
  );
};
export default LinkIconButtonV3;
